export function StatSectionCard({ name, value, label }) {
    return (
        <div
            className="stat-card"
        >
            <div className="stat-card-header">
                <span className="stat-card-name">{name}</span>
            </div>

            <p className="stat-score">{value}</p>

            <p className="stat-label">{label}</p>
        </div>
    );
}